export default {
    namespaced: true,
    state: {
        access_word_campaign_ids: {}
    },
    mutations: {
        // access_word用のキャンペーンIDをセット
        setAccessWordCampaignIds(state, access_word_campaign_ids) {
            state.access_word_campaign_ids = access_word_campaign_ids;
        }
    },
    actions: {},
    getters: {
        // access_word用のキャンペーンIDを取得
        getAccessWordCampaignIds(state) {
            return state.access_word_campaign_ids;
        }
    }
};
